import React, { useEffect, useState } from "react";
import { getWeb3, getWallet } from "./utils";
import Header from "./Header";
import NewTransfer from "./NewTransfer";
import TransferList from "./TransferList";

function App() {
  const [web3, setWeb3] = useState();
  const [accounts, setAccounts] = useState([]);
  const [wallet, setWallet] = useState();
  const [approvers, setApprovers] = useState([]);
  const [quorum, setQuorum] = useState();
  const [transfers, setTransfers] = useState([]);

  useEffect(() => {
    const init = async () => {
      const web3 = await getWeb3();
      setWeb3(web3);
      const accounts = await web3.eth.getAccounts();
      setAccounts(accounts);
      const wallet = await getWallet(web3);
      setWallet(wallet);
      const approvers = await wallet.methods.getApprovers().call();
      setApprovers(approvers);
      const quorum = await wallet.methods.quorum().call();
      setQuorum(quorum);
      const transfers = await wallet.methods.getTransfers().call();
      setTransfers(transfers);
    };

    init();
  }, []);

  if (
    !web3 ||
    accounts.length === 0 ||
    !wallet ||
    approvers.length === 0 ||
    !quorum
  ) {
    return <div>loading...</div>;
  }

  const createTransfer = async (transfer) => {
    await wallet.methods
      .createTransfer(transfer.amount, transfer.to)
      .send({ from: accounts[0] });
    const transfers = await wallet.methods.getTransfers().call();
    setTransfers(transfers);
  };

  const approveTransfer = async (transferId) => {
    await wallet.methods
      .approveTransfer(transferId)
      .send({ from: accounts[0] });
    const transfers = await wallet.methods.getTransfers().call();
    setTransfers(transfers);
    console.log({ transfers });
  };

  return (
    <div>
      Multisig Dapp
      <Header approvers={approvers} quorum={quorum} />
      <NewTransfer createTransfer={createTransfer} />
      <TransferList
        transfers={transfers}
        approveTransfer={approveTransfer}
        approvers={approvers}
      />
    </div>
  );
}

export default App;
